<portal-modal-header (onClose)="dismiss()">
  <i class="far fa-sparkles ms-1 me-2"></i>
  <span>{{ 'notification.type.RELEASE_NOTES' | translate }}</span>
</portal-modal-header>

<div class="notifications">
  <portal-notification-live-view
    [language]="language"
    [notifications]="notifications"
    [showPublicationDate]="true"
    [showTitle]="true"
  />
</div>

<portal-modal-footer [closeOnly]="true" (onCancel)="dismiss()"></portal-modal-footer>
